<div class="modal-header modalHeaderBlack">
  <h6 class="modal-title">{{ "master.NextOfKin" | translate }}</h6>
  <span aria-label="Close" class="close" (click)="onClick()" data-automation-attribute="span-close-dialog">
    <mat-icon matTooltip="{{ 'AddInternalNotes.close' | translate }}">clear</mat-icon>
  </span>
</div>
<div style="height: 85%; overflow: scroll;padding: 5px;position: relative;">
  <mat-tab-group class="tabGroupPersonalDetails" [(selectedIndex)]="selectedTabIndex">
    <mat-tab class="tabSubPersonalDetails">
      <ng-template mat-tab-label>
        {{ "RegistrationPage.addEditNok" | translate }}
      </ng-template>

      <div id="#referral">
        <form [formGroup]="formNextOfKin" #patientKinForm="ngForm" novalidate
          attr.data-automation-attribute="formUserPersonalDetails">

          <mat-grid-list cols="12" rowHeight="50px">
            <mat-grid-tile [colspan]="1">
              <app-master-form-field [label]="'RegistrationPage.prefix' | translate"
                [masterName]="masterAPI.PREFIX_MASTER" [formControlName]="'prefix'" [parentForm]="formNextOfKin"
                [isSubmitted]="patientKinForm.submitted" [defaultValue]="titleDefaultValue">
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.name" | translate
                  }}</mat-label>
                <input formControlName="name" type="text" matInput oninput="this.value = this.value.toUpperCase()"
                  maxlength="50" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <app-master-form-field [label]="'EncounterPage.relation' | translate"
                [masterName]="masterAPI.RELATION_MASTER" [formControlName]="'relation'" [parentForm]="formNextOfKin"
                [isSubmitted]="patientKinForm.submitted" [defaultValue]="relationDefaultValue">
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
                <mat-form-field class="full-width" appearance="outline">
                 <mat-label>{{
                  "EncounterPage.primaryID" | translate
                  }}</mat-label>
                    <mat-select [formControlName]="'identificationType'"
                      placeholder="Identification Type"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="primaryIdSearchNok"
                          [placeholderLabel]="'RegistrationPage.search' | translate"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let option of primaryIdFilteredListNok" 
                      [value]="option">
                        {{ option.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.primaryDocNo" | translate
                  }}</mat-label>
                <input [required]="false" formControlName="identificationNumber" type="text" maxlength="25" matInput
                  pattern="([a-zA-Z0-9\u0E00-\u0E7F,'\-._/!@#$%^&*\s]+)"
                  (input)="inputValidation.replaceSpaces($event)" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.phone" | translate
                  }}</mat-label>
                <input formControlName="phoneNumber" maxlength="15" type="text"  pattern="[0-9+-]+" matInput />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
          <mat-grid-list cols="12" rowHeight="50px">
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.address" | translate
                  }}</mat-label>
                <input formControlName="address" type="text" maxlength="100" matInput
                  pattern="([a-zA-Z0-9,'<>?-._[]{}|/!@#$%^&*\s]+)" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <app-master-form-field [label]="'EncounterPage.country' | translate"
                [masterName]="masterAPI.COUNTRY_MASTER" [formControlName]="'country'" [parentForm]="formNextOfKin"
                [isSubmitted]="patientKinForm.submitted"  (itemSelected)="getNOKStateList($event)" [defaultValue]="countryDefaultValue">
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <app-master-form-field [label]="'EncounterPage.state' | translate"
                [masterName]="masterAPI.STATE_MASTER_QUERY" [formControlName]="'state'" [parentForm]="formNextOfKin"
                [params]="nokCountryCode"  (itemSelected)="getNOKCityList($event)"[isSubmitted]="patientKinForm.submitted" [defaultValue]="stateDefaultValue">
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <app-master-form-field [label]="'EncounterPage.city' | translate"
                [masterName]="masterAPI.CITY_MASTER_QUERY" [formControlName]="'city'" [parentForm]="formNextOfKin"
                [params]="nokStateCode" [isSubmitted]="patientKinForm.submitted" [defaultValue]="cityDefaultValue"
                (itemSelected)="getSubDistrictForNOK($event)">
              </app-master-form-field>
            </mat-grid-tile>
           <mat-grid-tile [colspan]="2">
             <app-master-form-field [label]="'RegistrationPage.subArea' | translate" [masterName]="masterAPI.DIST_MASTER_QUERY"
               [formControlName]="'area'" [parentForm]="formNextOfKin" [params]="nokAreaCode"
               [isSubmitted]="patientKinForm.submitted" (itemSelected)="secondaryDistrictAreaSelected($event)"
               [defaultValue]="areaDefaultValue">
             </app-master-form-field>
           </mat-grid-tile>            
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.zipcode" | translate
                  }}</mat-label>
                <input formControlName="postcode" pattern="[a-zA-Z0-9]+" type="text" maxlength="10" matInput />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </form>
      </div>


    </mat-tab>
    <mat-tab class="tabSubPersonalDetails">
      <ng-template mat-tab-label>
        {{ "RegistrationPage.viewNok" | translate }}
      </ng-template>
      <div style="height: 15vh;overflow: scroll;">
        <table mat-table [dataSource]="dataSourceViewNokDetails" class="mat-elevation-z8">

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> {{ "common.nokName" | translate }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
          </ng-container>

          <!-- Relation Column -->
          <ng-container matColumnDef="relation">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.relation" | translate }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.relation?.desc }} </td>
          </ng-container>

          <!-- ID Type Column -->
          <ng-container matColumnDef="idType">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.identificationType" | translate }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.identificationType?.desc }} </td>
          </ng-container>

          <!-- ID Number Column -->
          <ng-container matColumnDef="idNumber">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.IdentificationNo" | translate }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.idNumber }} </td>
          </ng-container>

          <!-- Mobile Column -->
          <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.handphoneNo" | translate }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.phoneNumber}} </td>
          </ng-container>

          <!-- Address Column -->
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.address" | translate }} </th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <mat-icon matTooltip="Address Details" (click)="displayAddressDetails(element)">info</mat-icon>
            </td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> {{ "RegistrationPage.action" | translate }} </th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <mat-icon mat-mini-fab (click)="addexistingNok(element)" matTooltip="Add NOK">add_circle</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsViewNokDetails; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsViewNokDetails;"></tr>

        </table>
      </div>

    </mat-tab>
  </mat-tab-group>

  <button *ngIf="!isEditNok &&   selectedTabIndex === 0" (click)="addNextOfKin('add')" class="btnCyan add-btn"
    mat-mini-fab matTooltip="Add Next of Kin">
    <mat-icon>add</mat-icon>
  </button>
  <button *ngIf="isEditNok && selectedTabIndex === 0" (click)="addNextOfKin('update')" class="btnOrange add-btn"
    mat-mini-fab matTooltip="Save Next of Kin">
    <mat-icon>save</mat-icon>
  </button>

  <div class="divepisodeconversion">
    <div class="example-container">
      <table mat-table [dataSource]="dataSourceNextOfKin" class="height150 divFullWidth">
        <ng-container matColumnDef="nokName">
          <th mat-header-cell *matHeaderCellDef>
            {{ "common.nokName" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element ? element.name : "" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="relationship">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.relation" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{element.relation?element.relation.desc:""}}
          </td>
        </ng-container>

        <ng-container matColumnDef="idType">
          <th mat-header-cell *matHeaderCellDef>
            {{ "AppointmentPage.idType" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.identificationType ? element.identificationType.desc : ""}}
          </td>
        </ng-container>

        <ng-container matColumnDef="idNo">
          <th mat-header-cell *matHeaderCellDef>
            {{ "common.idNo" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.idNumber ? element.idNumber : "" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="mobileNo">
          <th mat-header-cell *matHeaderCellDef>
            {{ "AppointmentListPage.mobileNo" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.phoneNumber ? element.phoneNumber : "" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="isGuarantor">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.isguarantor" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            <mat-checkbox (change)="setGuarantorValue(element , $event)" [checked]="element.isGuarantor">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="Address">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.address" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;">
            <mat-icon matTooltip="Address Details" (click)="displayAddressDetails(element)">info</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.action" | translate }}
          </th>
          <td mat-cell *matCellDef="let element " style="text-align: center;">
            <mat-icon matTooltip="edit" (click)="editNOK(element)">
              edit
            </mat-icon>
            <mat-icon matTooltip="{{ 'payerInfo.delete' | translate }}"
              (click)="deleteNextOfKin(element)">delete</mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsNextOfKinDetails; sticky: true" class="tableHeaderGreen">
        </tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsNextOfKinDetails" class="tableRow"></tr>
      </table>
    </div>
  </div>
  <div style="text-align: right; margin: 10px;">
    <button class="btnCyan" mat-mini-fab (click)="saveNextOfKin()" matTooltip="Save Next of Kin">
      <mat-icon>save</mat-icon>
    </button>
  </div>
</div>